<ion-header
  class="ion-no-border"
  [ngClass]="
    platform !== platformRef.desktop
      ? platform === platformRef.tablet
        ? 'ion-header-modal-tablet'
        : 'ion-header-modal-mobile'
      : 'ion-header-modal-desktop'
  "
>
  <ion-toolbar>
    <ion-buttons *ngIf="platform === platformRef.desktop" slot="end">
      <ion-button data-cy="create-mpp-close-button" (click)="dismiss()">
        <ion-icon slot="icon-only" name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-label>
      <p class="title">{{ title | translate }}</p>
    </ion-label>
  </ion-toolbar>
</ion-header>

<ion-content
  [ngClass]="
    platform !== platformRef.desktop
      ? platform === platformRef?.tablet
        ? 'ion-content-modal-tablet'
        : 'ion-content-modal-mobile'
      : 'ion-content-modal-desktop'
  "
  tabletTouchMove
>
  <ion-grid>
    <!-- Type Tile -->
    <ion-row class="type-selection">
      <ion-card-title
        >{{ 'i18n.menuProfitPro.createModal.type' | translate }}
        <span class="required-text">*</span>
      </ion-card-title>
    </ion-row>
    <ion-row class="type-selection">
      <ion-col size="auto" *ngFor="let option of options">
        <ion-card
          (click)="selectOption(option)"
          [class.selected]="option.selected"
          class="type-card"
        >
          <div class="option-image">
            <ion-img [src]="option.image"></ion-img>
          </div>

          <ion-card-title class="type-title">{{ option.text }}</ion-card-title>
        </ion-card>
      </ion-col>
    </ion-row>

    <!-- Name Input -->
    <ion-row class="type-selection">
      <ion-card-title>
        {{ 'i18n.menuProfitPro.createModal.name' | translate }}
        <span class="required-text">*</span>
      </ion-card-title>
    </ion-row>
    <ion-row class="type-selection">
      <ion-item [class.invalid]="nameContainsEmojis || duplicateNameIndicator">
        <ion-input
          [(ngModel)]="data.name"
          [placeholder]="'i18n.menuProfitPro.createModal.nameInput' | translate"
          [maxlength]="length"
          (ngModelChange)="onNameChange(data.name)"
          data-cy="name-input-create-modal"
        ></ion-input>
      </ion-item>
      <p *ngIf="nameContainsEmojis" class="invalid-character">
        {{ 'i18n.menuProfitPro.createModal.invalidCharacterError' | translate }}
      </p>
      <p
        *ngIf="duplicateNameIndicator"
        class="invalid-character"
        data-cy="create-recipe-name-exists-text"
      >
        {{ 'i18n.menuProfitPro.createModal.nameDuplicateError' | translate }}
      </p>
    </ion-row>
    <!-- Description -->
    <ion-row class="type-selection">
      <ion-card-title
        >{{ 'i18n.menuProfitPro.createModal.description' | translate }}
      </ion-card-title>
    </ion-row>
    <ion-row class="type-selection">
      <ion-item [class.invalid]="descriptionContainsEmojis">
        <ion-input
          [(ngModel)]="data.description"
          [placeholder]="
            'i18n.menuProfitPro.createModal.descriptionInput' | translate
          "
          [maxlength]="length"
          (ionInput)="onDescriptionChange(data.description)"
          data-cy="description-input-create-modal"
        ></ion-input>
      </ion-item>
      <p *ngIf="descriptionContainsEmojis" class="invalid-character">
        {{ 'i18n.menuProfitPro.createModal.invalidCharacterError' | translate }}
      </p>
    </ion-row>
    <!-- Lock Permissions -->
    <ion-row class="type-selection">
      <ion-card-title>
        {{ 'i18n.menuProfitPro.createModal.permissionsSection' | translate }}
      </ion-card-title>
    </ion-row>
    <ion-row class="type-selection">
      <ion-item class="lock-indicator-toggle-container">
        <p *ngIf="isInternal">
          {{ 'i18n.menuProfitPro.createModal.privacyTogglePublic' | translate }}
        </p>
        <ion-toggle
          id="public-setting-toggle"
          data-cy="public-setting-toggle"
          mode="ios"
          [(ngModel)]="data.publicPermission"
          *ngIf="isInternal"
        >
        </ion-toggle>
        <p>{{ 'i18n.menuProfitPro.createModal.lockIndicator' | translate }}</p>
        <ion-icon
          id="hover-info-trigger"
          data-cy="lock-information-icon"
          name="information-circle-outline"
        ></ion-icon>
        <ion-toggle
          id="lock-indicator-toggle"
          data-cy="lock-indicator-toggle"
          mode="ios"
          [(ngModel)]="data.lockIndicator"
        >
        </ion-toggle>
        <ion-popover
          data-cy="lock-ind-popover"
          class="lock-ind-popover"
          mode="ios"
          trigger="hover-info-trigger"
          trigger-action="hover"
          side="top"
          (didPresent)="shouldCloselockInfoPopover($event)"
          (didDismiss)="removeWindowListener()"
        >
          <ng-template>
            <app-lock-info-popover></app-lock-info-popover>
          </ng-template>
        </ion-popover>
      </ion-item>
    </ion-row>
  </ion-grid>
</ion-content>

<ion-footer
  class="ion-footer-modal"
  [class.ion-footer-modal-desktop]="platform === platformRef.desktop"
>
  <ion-toolbar>
    <ion-buttons>
      <ion-button
        data-cy="create-mpp-cancel-button"
        [class.usf-outline-green-mobile-modal-button]="
          platform === platformRef.mobile
        "
        [class.usf-outline-green-dsktp-tblt-modal-button]="
          platform !== platformRef.mobile
        "
        (click)="dismiss()"
      >
        {{ 'i18n.common.cancel' | translate }}
      </ion-button>
      <ion-button
        data-cy="create-mpp-modal-create-button"
        [ngClass]="
          !data.type ||
          data.name.length < 1 ||
          nameContainsEmojis ||
          descriptionContainsEmojis ||
          duplicateNameIndicator
            ? platform === platformRef.mobile
              ? 'usf-fill-disabled-mobile-modal-button'
              : 'usf-fill-disabled-dsktp-tblt-modal-button'
            : platform === platformRef.mobile
              ? 'usf-fill-green-mobile-modal-button'
              : 'usf-fill-green-dsktp-tblt-modal-button'
        "
        (click)="createMpp()"
      >
        {{ 'i18n.common.create' | translate }}
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>
